import { render, staticRenderFns } from "./CatalogProductsFrom.vue?vue&type=template&id=10509c3b&"
import script from "./CatalogProductsFrom.vue?vue&type=script&lang=js&"
export * from "./CatalogProductsFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports